/**
 * SOLID Review
 * S — Strong. One use case: GDPR Art. 17, step two — the account deleted with the code, and the tab signed out.
 * O — Strong. What a sign-out forgets is the sign-out's.
 * L — Strong. Implements its use-case role exactly.
 * I — Strong. `execute`.
 * D — Strong. The legal-server port and the sign-out use case, injected — the sign-out by its role.
 */
import type { IContextRequest } from '../ports/IContextRequest';
import type { ICommandNothing } from '../../domain/ports/schemas/TableMoves';
import type { ICommandDeleteAccount } from '../../domain/ports/schemas/LegalMoves';
import type { TPortOutcome } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import type { IConfigDepLegal } from './IConfigDepLegal';

const NOTHING: ICommandNothing = {};

/** The account deleted (FE4a): the tab signs out — the same sign-out as Log out. */
export class DeleteAccountUseCase implements IUseCase<ICommandDeleteAccount, TPortOutcome> {
  constructor(private readonly deps: IConfigDepLegal) {}

  async execute(ctx: IContextRequest, command: ICommandDeleteAccount): Promise<TPortOutcome> {
    const deleted = await this.deps.legal.deleteAccount(ctx, command);
    if (!deleted.success) return deleted;
    return this.deps.account.execute(ctx, NOTHING);
  }
}
